<template>
    <label>
        <slot />
        <template v-if="required">
            <span class="text-red-500 required-asterisk" aria-hidden="true"
                >*</span
            >
            <span class="required-sr-only">required</span>
        </template>
    </label>
</template>

<script setup>
// Marks a form field's label as required.
//
// This is purely a visual indicator: it reports what the form's validation
// schema already enforces and does not make anything required on its own,
// so the `required` prop must be kept in step with the schema by hand.
defineProps({
    required: {
        type: Boolean,
        default: false,
    },
});
</script>

<style scoped>
.required-asterisk {
    margin-left: 0.25rem;
}

/* Exposed to screen readers only, so the asterisk is announced as a word. */
.required-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}
</style>
